import * as React from 'react';

const SvgAdminBookings = (props) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={'1em'}
    height={'1em'}
    viewBox={'0 0 32 32'}
    {...props}
  >
    <path
      d="M31.016 25.2a3.373 3.373 0 0 1-.835 5.375 12.069 12.069 0 0 1-8.761 1.027C13.602 29.634 2.366 18.398.398 10.58A12.068 12.068 0 0 1 1.425 1.82 3.373 3.373 0 0 1 6.799.984l3.336 3.334a3.35 3.35 0 0 1 .712 3.725 6.203 6.203 0 0 1-1.245 1.875c-3.814 3.814 8.667 16.296 12.48 12.48a6.203 6.203 0 0 1 1.877-1.25 3.348 3.348 0 0 1 3.724.712l3.333 3.34Zm-8.614-10.802a1.6 1.6 0 0 0 1.6-1.6v-3.2h3.2a1.6 1.6 0 1 0 0-3.2h-3.2v-3.2a1.6 1.6 0 0 0-3.2 0v3.2h-3.2a1.6 1.6 0 1 0 0 3.2h3.2v3.2a1.6 1.6 0 0 0 1.6 1.6Z"
      fill='currentColor'
    />
  </svg>
);
export default SvgAdminBookings;
